import React, { useState, useEffect } from "react";
import ProductsManager from "../../modules/productManager";
import { Bar } from "react-chartjs-2";
import { Timeline } from "antd";

const ProductsBarChart = ({ routerProps }) => {
  const [products, setAllProducts] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [categoryAmount, setCategoryAmount] = useState([]);

  const getProducts = () => {
    ProductsManager.getProducts().then((resp) => {
      setAllProducts(resp);
    });
  };

  function filterByProductType(arrayOfCategories) {
    const categoryAmountArray = [];
    arrayOfCategories.forEach((cat) => {
      const filteredProducts = products.filter((prod) => {
        return prod.product_type.name === cat;
      });
      categoryAmountArray.push(filteredProducts.length);
    });
    setCategoryAmount(categoryAmountArray);
    console.log(categoryAmountArray);
    return categoryAmountArray;
  }

  const productChart = () => {
    const categoryLabelArray = [
      "Clothing",
      "Electronics",
      "Exercise Equipment",
      "Games & Toys",
      "Home & Garden",
      "Outdoor Gear",
      "Sporting Goods",
      "Tools",
      "Other",
    ];
    setChartData({
      labels: categoryLabelArray,
      datasets: [
        {
          label: "Product Category Data",
          data: filterByProductType(categoryLabelArray),
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(54, 162, 235, 0.2)",
            "rgba(255, 206, 86, 0.2)",
            "rgba(75, 192, 192, 0.2)",
            "rgba(153, 102, 255, 0.2)",
            "rgba(255, 159, 64, 0.2)",
            "rgba(60, 179, 113, 0.2)",
            "rgb(255, 165, 0, 0.2)",
            "rgb(106, 90, 205, 0.2)",
          ],
          borderWidth: 4,
        },
      ],
    });
  };

  useEffect(() => {
    getProducts();
  }, []);

  useEffect(() => {
    productChart();
  }, [products]);

  return (
    <div>
      <Bar data={chartData} height={80} />
    </div>
  );
};
export default ProductsBarChart;
